import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {imageMap} from "../../../../images/imageMap.ts";
import {WhatRouter} from "../../../../components/help/CommonQuestions.tsx";
import {ScrollToAnchorPoint} from "../../../../util/ScrollToAnchor.tsx";

export default function PortForwardArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className={'article'}>
                    <h2>
                        Vælg din router for at finde vejledning
                    </h2>
                    <div className={'choose-router-container'}>
                        <a href={'#fiber'} className={'choose-router'}>
                            <div className={'image-container'}>
                                <img
                                    className={'no-br'}
                                    src={imageMap.help.choose_router.zyxel_ex33}
                                    alt={'Billede af vores Zyxel EX/VMG router.'}
                                />
                            </div>
                            <span className={'text'}>
                                Zyxel EX33/EX36/VMG
                            </span>
                        </a>
                        <a href={'#fiber'} className={'choose-router'}>
                            <div className={'image-container'}>
                                <img
                                    className={'no-br'}
                                    src={imageMap.help.choose_router.zyxel_ex56}
                                    alt={'Billede af vores Zyxel EX5601 router.'}
                                />
                            </div>
                            <span className={'text'}>
                                Zyxel EX5601
                            </span>
                        </a>
                        <a href={'#sagemcom-3890'} className={'choose-router'}>
                            <div className={'image-container'}>
                                <img
                                    className={'no-br'}
                                    src={imageMap.help.choose_router.sagemcom_3890}
                                    alt={'Billede af vores Sagemcom 3890 router.'}
                                />
                            </div>
                            <span className={'text'}>
                                Sagemcom 3890
                            </span>
                        </a>
                        <a href={'#sagemcom-3896'} className={'choose-router'}>
                            <div className={'image-container'}>
                                <img
                                    className={'no-br'}
                                    src={imageMap.help.choose_router.sagemcom_3896}
                                    alt={'Billede af vores Sagemcom 3896 router.'}
                                />
                            </div>
                            <span className={'text'}>
                                Sagemcom 3896
                            </span>
                        </a>
                        <a href={'#mbb'} className={'choose-router'}>
                            <div className={'image-container'}>
                                <img
                                    className={'no-br'}
                                    src={imageMap.help.choose_router.zyxel_nr5307}
                                    alt={'Billede af vores Zyxel NR5307 router.'}
                                />
                            </div>
                            <span className={'text'}>
                                Zyxel NR5307
                            </span>
                        </a>
                        <a href={'#mbb'} className={'choose-router'}>
                            <div className={'image-container'}>
                                <img
                                    className={'no-br'}
                                    src={imageMap.help.choose_router.huawei_h158}
                                    alt={'Billede af vores Huawei H158 router.'}
                                />
                            </div>
                            <span className={'text'}>
                                Huawei H158
                            </span>
                        </a>
                        <a href={'#not-sure'} className="not-sure">
                            <span className={'text'}>
                                Ved du ikke hvilken router du har?
                            </span>
                        </a>
                    </div>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'fiber'} className={'id-anchor--help'}/>
                <div className="article article--connect">
                    <div className="paragraph">
                        <h2>Zyxel EX33, EX36, EX56 og VMG</h2>
                        <h3>Inden du går i gang</h3>
                        <ul className="list list--bullet">
                            <li>
                                <p>For at du kan lave Port Forward, skal du have en dynamisk eller fast IP-adresse.</p>
                                <ul className="list list--bullet">
                                    <li>Som standard har du en forbindelse bag CGNAT.</li>
                                    <li>
                                        Har du ikke en af de to typer IP-adresser, kan du sende en mail til os på <a href="mailto:kundeservice@hiper.dk">kundeservice@hiper.dk</a> og skrive, om du vil have en dynamisk IP (gratis) eller fast IP (19 kr./md.).
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Enheden, du vil forwarde til, skal lytte på den korrekte port.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="article article--connect">
                    <h3>Sådan gør du</h3>
                    <ol className="list list--number list--image">
                        <li><p>Sørg for at du er forbundet til routerens netværk enten via wifi eller netværkskabel.</p></li>
                        <li>
                            <p>
                                Forbind til din routers admin-panel på <a
                                href="http://fiber.hiper.dk"
                                rel="nofollow"
                                target="_blank"
                            >fiber.hiper.dk</a> (som sender dig til <a href="http://192.168.1.1" rel="nofollow" target="_blank">192.168.1.1</a>).
                            </p>
                            <p>
                                Dit login står bag på din router:
                            </p>
                            <ul className="list list--bullet list--compact">
                                <li><p><strong>Brugernavn:</strong> admin (med lille a)</p></li>
                                <li><p><strong>Adgangskode:</strong> står ud for <strong>Login Password</strong></p></li>
                            </ul>
                        </li>
                        <img
                            className="max-height"
                            src={imageMap.help.network.gui.zyxel_ex3.gui_login}
                            alt="Grafik af Zyxel routers bagside, som viser Login Password."
                        />
                        <li>
                            <p>
                                Når du er logget ind i din router, skal du først finde MAC-adresse og den lokale IP-adresse til enheden, du vil port forwarde til:
                            </p>
                            <ul className="list list--number list--compact">
                                <li><p>Find din enhed i routerens interface.</p></li>
                                <li><p>På startskærmen efter log-in skal du klikke på <strong>{">"}</strong> i <strong>Connectivity</strong>.</p></li>
                                <li><p>Find enheden, du vil forwarde til.</p></li>
                                <li><p>Notér enhedens MAC- og lokale IP-adresse.</p></li>
                            </ul>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel.zyxelGuiHomeConnectivity}
                            alt="Grafik af Zyxel routerens GUI der viser Connectivity."
                        />
                        <li><p>Åbn menuen <strong>&#9776;</strong> i øverste højre hjørne.</p></li>
                        <li><p>Vælg <strong>Network Settings</strong> {">"} <strong>Home Networking</strong>.</p></li>
                        <img src={imageMap.help.network.gui.zyxel.zyxelGuiMenuHomeNetworking} alt="Grafik af Zyxel routerens GUI der viser en menu."/>
                        <li><p>Klik på <strong>Static DHCP</strong>.</p></li>
                        <li>
                            <p>
                                Tryk på <strong>+</strong> ud for <strong>Static DHCP Configuration</strong>.
                                Så sørger du for, at din enhed ikke skifter IP-adresse.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel.zyxelGuiStaticDHCPAdd}
                            alt="Grafik af Zyxel routerens GUI der viser Static DHCP menu."
                        />
                        <li><p>Sæt <strong>Active</strong> til at være aktiveret.</p></li>
                        <li><p>Indtast MAC-adresse og lokal IP-adresse, som du noterede tidligere.</p></li>
                        <img
                            src={imageMap.help.network.gui.zyxel.zyxelGuiStaticDHCP}
                            alt="Grafik af Zyxel routerens GUI der viser statisk DHCP onfiguration."
                        />
                        <li>
                            <p>
                                Nu kan du påbegynde port forward.
                            </p>
                        </li>
                        <li>
                            <p>
                                Tryk igen på menuen <strong>&#9776;</strong>
                            </p>
                        </li>
                        <li><p>Vælg <strong>Network Setting</strong> {">"} <strong>NAT</strong>.</p></li>
                        <li><p>Vælg <strong>Add new rule</strong>.</p></li>
                        <li><p>Navngiv din port forward.</p></li>
                        <li>
                            <p>
                                Indtast porten du vil åbne.
                            </p>
                            <p>
                                I eksemplet nedenfor bruger vi port 8080.
                                Hvis du kun skal åbne én port, skriv da den samme port i både <strong>Start Port</strong> og <strong>End Port</strong>.
                            </p>
                        </li>
                        <li><p>Tilføj den lokale IP-adresse, du noterede tidligere, i <strong>Server IP Address</strong>.</p></li>
                        <li>
                            <p>
                                Vælg <strong>Protocol</strong>.
                                Er du i tvivl om, hvilken du skal bruge, kan du vælge <strong>TCP/UDP</strong>.
                            </p>
                            <p>
                                Når du er færdig, ser det nogenlunde således ud:
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel.zyxelGuiPortForwardAdd}
                            alt="Grafik af Zyxel routerens GUI der viser tilføjelse af ny regel."
                        />
                        <li><p>Tryk på <strong>OK</strong> &ndash; nu har du lavet en port forward-regel.</p></li>
                    </ol>
                </div>
                <div className="article">
                    <div className="paragraph">
                        <h3>Vil du oprette en port forward-regel til port 21, 22, 23, 80, 161 eller 443?</h3>
                        <p>
                            Så skal du ændre i den pågældende port, da routeren har reserveret portene ovenfor:
                        </p>
                    </div>
                    <ol className="list list--number list--image">
                        <li><p>Du kan gøre det ved at klikke på menuen <strong>&#9776;</strong> i højre hjørne.</p></li>
                        <li><p>Gå ind under <strong>Maintenance</strong>.</p></li>
                        <li><p>Vælg <strong>Remote Management</strong>.</p></li>
                        <li>
                            <p>Vil du bruge port 80?</p>
                            <ul className="list list--number list--compact">
                                <li><p>Skriv <strong>8080</strong> i stedet for <strong>80</strong> i feltet <strong>HTTP</strong>.</p></li>
                                <li>
                                    <p>
                                        Vælg <strong>Tryk</strong>.
                                        Så vil det se således ud:
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>Vil du bruge 21, 22, 23, 161 eller 443?</p>
                            <ul className="list list--number list--compact">
                                <li>
                                    <p>
                                        Find porten du vil bruge og tilføj et 1-tal til sidst i feltet <strong>Port</strong>.<br/>
                                        F.eks.: vil du bruge port 443, skal du skrive &ldquo;4431&rdquo; i <strong>Port</strong>.
                                    </p>
                                </li>
                                <li><p>Tryk <strong>Apply</strong>.</p></li>
                            </ul>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel.zyxelGuiRemoteManagement}
                            alt="Grafik af Zyxel routerens interface der viser Remote Management."
                        />
                    </ol>
                    <div className="paragraph">
                        <p>
                            <strong>Husk:</strong>{' '}
                            Hvis du ændrer i port 8, 21, 22, 23, 80, 161 eller 443 er det sværere for os at hjælpe dig, hvis du får brug for support.
                            Vi bruger nemlig portene til at sikre, at dit internet kører som det skal.
                        </p>
                    </div>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'sagemcom-3890'} className={'id-anchor--help'}/>
                <div className="article article--connect">
                    <div className="paragraph">
                        <h2>Sagemcom 3890</h2>
                        <h3>Inden du går i gang</h3>
                        <ul className="list list--bullet">
                            <li>
                                Du skal have en dynamisk IP-adresse for at lave port forward.
                                <ul className="list list--bullet">
                                    <li>Som standard har du en forbindelse bag CGNAT.</li>
                                    <li>
                                        Har du ikke en dynamisk IP-adresse, kan du skrive til os på <a href="mailto:kundeservice@hiper.dk">kundeservice@hiper.dk</a> &ndash; så opretter vi en til dig helt gratis.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Enheden, du vil forwarde til, skal lytte på den rigtige port.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="article article--connect">
                    <h3>Sådan gør du</h3>
                    <ol className="list list--number list--image">
                        <li><p>Sørg for at du er forbundet til routerens netværk enten via wifi eller netværkskabel.</p></li>
                        <li>
                            <p>
                                Forbind til din routers admin-panel på <a
                                href="http://coax.hiper.dk"
                                rel="nofollow"
                                target="_blank"
                            >coax.hiper.dk</a> (som sender dig til <a href="http://192.168.0.1" rel="nofollow" target="_blank">192.168.0.1</a>).
                            </p>
                            <p>
                                Dit login står på siden af din router
                            </p>
                            <ul className="list list--bullet list--compact">
                                <li><p><strong>Brugernavn:</strong> &ldquo;admin&rdquo; (med lille a)</p></li>
                                <li><p><strong>Adgangskode:</strong> står ud for <strong>Admin password</strong> på siden af din router</p></li>
                            </ul>
                        </li>
                        <img src={imageMap.help.network.gui.sagemcom_3890.router_login} alt="Brugernavn og kodeord på din router"/>
                        <li><p>Klik på <strong>Mit WiFimodem</strong> og vælg <strong>LAN</strong>.</p></li>
                        <img className="no-br" src={imageMap.help.network.gui.sagemcom_3890.sagemGuiTabsLan} alt="Vælg LAN under Mit WiFimodem"/>
                        <li>
                            <p>
                                Find MAC- og IP-adressen på enheden, du vil port forwarde til, under <strong>DHCP-rettighedstider</strong>.<br/>
                                Notér dem &ndash; du skal bruge dem senere.
                            </p>
                        </li>
                        <img
                            className="no-br"
                            src={imageMap.help.network.gui.sagemcom.sagemGuiDHCPRettighedstider}
                            alt="Under DHCP-rettighedstider finder du MAC- og IP-adressen på enheden du vil port forward til"
                        />
                        <li className="warning">
                            <p>
                                Hvis der er flere enheder, kan du finde enhedens MAC- og IP-adresse her (Windows):
                            </p>
                            <ul className="list list--number list--compact">
                                <li><p>Åbn CMD</p></li>
                                <li><p>Skriv <code className="inline-code">ipconfig /all</code> og tryk enter</p></li>
                                <li><p>Find <code className="inline-code">Physical Address</code> som er din mac adresse</p></li>
                                <li><p>Find <code className="inline-code">IPv4 Address</code> som er din IP</p></li>
                            </ul>
                        </li>
                        <img
                            className="no-br"
                            src={imageMap.help.network.cmdIpconfig}
                            alt="Sådan finder du MAC- og IP-adresse ved flere enheder"
                        />
                        <li><p>Tryk på <strong>Tilføj reserveret adresse</strong> under <strong>DHCP</strong>.</p></li>
                        <img
                            className="no-br"
                            src={imageMap.help.network.gui.sagemcom_3890.sagemGuiIpReservationAdd}
                            alt="Tilføj reserveret adresse i port forward processen"
                        />
                        <li className="warning">
                            <p>
                                Sker der ikke noget når du trykker <strong>Tilføj reserveret adresse</strong>?
                            </p>
                            <p>
                                Så er det muligvis fordi din <strong>IPv4-rettighedstid</strong> under <strong>DHCP</strong> har en ugyldig lease time.<br/>
                                Hvis dette er tilfældet, skal du ændre <strong>IPv4-rettighedstid</strong> fra <strong>Andet</strong> til <strong>1&nbsp;dag</strong>.
                            </p>
                        </li>
                        <img
                            className="no-br"
                            src={imageMap.help.network.gui.sagemcom.sagemGuiInvalidLeaseTime}
                            alt="IPv4-rettighedstid under DHCP med ugyldig lease time"
                        />
                        <li>
                            <p>
                                Vælg din enhed under <strong>Enhedens navn</strong> og sikr dig at MAC-adressen er ens med den, du noterede.<br/>
                                Under <strong>IPv4-adresse</strong> skal du indtaste den IPv4-adresse, du noterede.
                            </p>
                            <p>
                                Det reserverer din interne IP-adresse, så den ikke ændrer sig.
                            </p>
                        </li>
                        <img
                            className="no-br"
                            src={imageMap.help.network.gui.sagemcom_3890.sagemGuiIpReservation}
                            alt="Reservation af intern IP-adresse"
                        />
                        <li>
                            <p>
                                Gå tilbage til forsiden ved at trykke på huset.<br/>
                                Vælg så <strong>Adgangskontrol</strong> og derefter <strong>Omdirigering af port</strong>.
                            </p>
                        </li>
                        <img className="no-br" src={imageMap.help.network.gui.sagemcom_3890.sagemGuiTabsPortForward} alt="Omdirrigering af port"/>
                        <li>
                            <p>Indtast følgende under <strong>Tilføj regler manuelt</strong>:</p>
                            <ul className="list list--bullet list--compact">
                                <li><p>Et valgfrit navn på din port forward i <strong>Standardtjenestenavn</strong>.</p></li>
                                <li><p>Porten, du vil åbne, i <strong>Ekstern port</strong> og <strong>Intern port</strong>.</p></li>
                                <li><p>Enhedens IP-adresse i <strong>Intern host</strong>.</p></li>
                            </ul>
                        </li>
                        <img
                            className="no-br"
                            src={imageMap.help.network.gui.sagemcom_3890.sagemGuiPortForwardAdd}
                            alt="Manuel tilføjelse af regler ved port forward"
                        />
                        <li>
                            <p>
                                Tryk <strong>Tilføj</strong>.<br/>
                                Nu står din port forward-regel nedenunder.
                            </p>
                        </li>
                        <li><p>Aktivér din port forward-regel ved at sætte knappen under <strong>Aktivér</strong> til <strong>ON</strong>.</p></li>
                        <img
                            className="no-br"
                            src={imageMap.help.network.gui.sagemcom_3890.sagemGuiPortForwardActive}
                            alt="Aktivér din port forward-regel"
                        />
                    </ol>
                </div>
                <div className="article">
                    <div className="paragraph">
                        <h3>Vil du teste din port forward-regel?</h3>
                        <p>
                            Det kan du gøre på <a href="https://portchecker.co/" rel="external nofollow" target="_blank">portchecker.co</a>.{' '}
                            <strong>Husk</strong> at tænde enheden, du har forwardet til.
                        </p>
                    </div>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'sagemcom-3896'} className={'id-anchor--help'}/>
                <div className="article article--connect">
                    <div className="paragraph">
                        <h2>Sagemcom 3896</h2>
                        <h3>Inden du går i gang</h3>
                        <ul className="list list--bullet">
                            <li>
                                <p>
                                    Du skal have en dynamisk IP-adresse for at lave port forward.
                                </p>
                                <ul className="list list--bullet">
                                    <li>Som standard har du en forbindelse bag CGNAT.</li>
                                    <li>
                                        Har du ikke en dynamisk IP-adresse, kan du skrive til os på <a href="mailto:kundeservice@hiper.dk">kundeservice@hiper.dk</a> &ndash; så opretter vi en til dig helt gratis.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Enheden, du vil forwarde til, skal lytte på den rigtige port.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="article article--connect">
                    <h3>Sådan gør du</h3>
                    <ol className="list list--number list--image">
                        <li><p>Sørg for at du er forbundet til routerens netværk enten via wifi eller netværkskabel.</p></li>
                        <li>
                            <p>
                                Forbind til din routers admin-panel på <a
                                href="http://coax.hiper.dk"
                                rel="nofollow"
                                target="_blank"
                            >coax.hiper.dk</a> (som sender dig til <a href="http://192.168.0.1" rel="nofollow" target="_blank">192.168.0.1</a>).
                            </p>
                            <p>
                                Dit login står på siden af din router:
                            </p>
                            <ul className="list list--bullet list--compact">
                                <li><p><strong>Brugernavn:</strong> &ldquo;admin&rdquo; (med lille a)</p></li>
                                <li><p><strong>Adgangskode:</strong> står ud for <strong>Admin password</strong> under din router</p></li>
                            </ul>
                        </li>
                        <img
                            src={imageMap.help.network.gui.sagemcom_3896.router_login}
                            alt="Brugernavn og kodeord på din router"/>
                        <li><p>Klik på <strong>Min Sagemcom Router</strong>.</p></li>
                        <img
                            className={'no-br'}
                            src={imageMap.help.network.gui.sagemcom_3896.home_router}
                            alt="Vælg LAN under Mit WiFimodem"/>
                        <li><p>Vælg <strong>LAN</strong>.</p></li>
                        <img
                            className={'no-br'}
                            src={imageMap.help.network.gui.sagemcom_3896.tabs_lan}
                            alt="Vælg LAN under Mit WiFimodem"
                        />
                        <li>
                            <p>
                                Find MAC- og IP-adressen på enheden, du vil port forwarde til, under <strong>DHCP-rettighedstider</strong>.<br/>
                                Notér dem &ndash; du skal bruge dem senere.
                            </p>
                        </li>
                        <img
                            className={'no-br'}
                            src={imageMap.help.network.gui.sagemcom.sagemGuiDHCPRettighedstider}
                            alt="Under DHCP-rettighedstider finder du MAC- og IP-adressen på enheden du vil port forward til"
                        />
                        <li className="warning">
                            <p>
                                Hvis der er flere enheder, kan du finde enhedens MAC- og IP-adresse her (Windows):
                            </p>
                            <ul className="list list--number list--compact">
                                <li><p>Åbn CMD</p></li>
                                <li><p>Skriv <code className="inline-code">ipconfig /all</code> og tryk enter</p></li>
                                <li><p>Find <code className="inline-code">Physical address</code> som er din mac adresse</p></li>
                                <li><p>Find <code className="inline-code">IPv4 address</code> som er din IP</p></li>
                            </ul>
                        </li>
                        <img
                            className="no-br"
                            src={imageMap.help.network.cmdIpconfig}
                            alt="Sådan finder du MAC- og IP-adresse ved flere enheder"
                        />
                        <li><p>Tryk på <strong>Tilføj reserveret adresse</strong> under <strong>DHCP</strong>.</p></li>
                        <img
                            className="no-br"
                            src={imageMap.help.network.gui.sagemcom_3896.ip_reservation_add}
                            alt="Tilføj reserveret adresse i port forward processen"
                        />
                        <li className="warning">
                            <p>
                                Sker der ikke noget når du trykker <strong>Tilføj reserveret adresse</strong>?
                            </p>
                            <p>
                                Så er det muligvis fordi din <strong>IPv4-rettighedstid</strong> under <strong>DHCP</strong> har en ugyldig lease time.<br/>
                                Hvis dette er tilfældet, skal du ændre <strong>IPv4-rettighedstid</strong> fra <strong>Andet</strong> til <strong>1&nbsp;dag</strong>.
                            </p>
                        </li>
                        <img
                            className="no-br"
                            src={imageMap.help.network.gui.sagemcom.sagemGuiInvalidLeaseTime}
                            alt="IPv4-rettighedstid under DHCP med ugyldig lease time"
                        />
                        <li>
                            <p>
                                Vælg din enhed under <strong>Enhedens navn</strong> og sikr dig at MAC-adressen er ens med den, du noterede.<br/>
                                Under <strong>IPv4-adresse</strong> skal du indtaste den IPv4-adresse, du noterede.
                            </p>
                            <p>
                                Det reserverer din interne IP-adresse, så den ikke ændrer sig.
                            </p>
                        </li>
                        <img
                            className="no-br"
                            src={imageMap.help.network.gui.sagemcom_3896.ip_reservation}
                            alt="Reservation af intern IP-adresse"
                        />
                        <li>
                            <p>
                                Gå tilbage til forsiden ved at trykke på huset.<br/>
                                Vælg så <strong>Adgangskontrol</strong> og derefter fanen <strong>Omdirigering af port</strong>.
                            </p>
                        </li>
                        <img className="no-br" src={imageMap.help.network.gui.sagemcom_3896.tabs_port_forward} alt="Omdirrigering af port"/>
                        <li>
                            <p>Indtast følgende under <strong>Tilføj regler manuelt</strong>:</p>
                            <ul className="list list--bullet list--compact">
                                <li><p>Et valgfrit navn til din port forward i <strong>Beskrivelse</strong>.</p></li>
                                <li><p>Enhedens IP-adresse i <strong>Lokal IP</strong>.</p></li>
                                <li><p><code className={'inline-code'}>0.0.0.0</code> i <strong>Fjern-IP</strong>.</p></li>
                                <li><p>Porten, du vil åbne, i <strong>Lokal port</strong> og <strong>Fjernport</strong>.</p></li>
                            </ul>
                        </li>
                        <img
                            className="no-br"
                            src={imageMap.help.network.gui.sagemcom_3896.port_forward_add}
                            alt="Manuel tilføjelse af regler ved port forward"
                        />
                        <li><p>Nu har du oprettet og aktiveret en port forward regel på din router.</p></li>
                    </ol>
                </div>
                <div className="article">
                    <div className="paragraph">
                        <h4>Vil du teste din port forward-regel?</h4>
                        <p>
                            Det kan du gøre på <a href="https://portchecker.co/" rel="external nofollow" target="_blank">portchecker.co</a>.{' '}
                            <strong>Husk</strong> at tænde enheden, du har forwardet til.
                        </p>
                    </div>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'mbb'} className={'id-anchor--help'}/>
                <div className="article">
                    <div className="paragraph">
                        <h2>Zyxel NR5307 og Huawei H158</h2>
                        <p>Det er desværre ikke muligt at lave port forward på din 5G-router.</p>
                    </div>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'not-sure'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <div className={'paragraph'}>
                        <h2>{WhatRouter.question}</h2>
                        {WhatRouter.answer}
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "udstyr",
                        "article": "vlan-tagging",
                        "name": "Guide til VLAN-tagging"
                    },
                    {
                        "category": "udstyr",
                        "article": "bridge-mode",
                        "name": "Guide til bridge mode"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "ip-adresse",
                        "name": "IP-adresse"
                    },
                    {
                        "category": "udstyr",
                        "article": "brug-af-egen-router",
                        "name": "Kan jeg bruge min egen router?"
                    }
                ]}
            />
        </>
    )
}
